"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebBData = exports.AndroidBData = exports.IosBData = exports.BDataMobile = exports.BData = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const loader_1 = require("./loader");
const web_ui_framework_2 = require("@gruposantander/web-ui-framework");
class BData extends web_ui_framework_1.Library {
    constructor(name, biocathLoader) {
        super(name, biocathLoader);
        return (0, web_ui_framework_2.withLibraryLoadCheck)(this);
    }
    setCustomerSessionId(customerSessionId) {
        var _a;
        try {
            (_a = window.cdApi) === null || _a === void 0 ? void 0 : _a.setCustomerSessionId(customerSessionId);
        }
        catch (e) {
            console.error(e);
        }
    }
    setContext(context) {
        var _a;
        try {
            (_a = window.cdApi) === null || _a === void 0 ? void 0 : _a.changeContext(context);
        }
        catch (e) {
            console.error(e);
        }
    }
}
exports.BData = BData;
class BDataMobile extends web_ui_framework_1.Library {
    constructor(name, biocathLoader) {
        super(name, biocathLoader);
        return (0, web_ui_framework_2.withLibraryLoadCheck)(this);
    }
}
exports.BDataMobile = BDataMobile;
class IosBData extends BDataMobile {
    constructor(baseUrl, slaveUrl) {
        super('IosBData', new loader_1.IosBDataLoader(baseUrl, slaveUrl));
    }
    setCustomerSessionId(_customerSessionId) {
        throw new Error('Shouldn`t call "setCustomerSessionId" method in IOS');
    }
    setContext(_context) {
        throw new Error('Shouldn`t call "setContext" method in IOS');
    }
}
exports.IosBData = IosBData;
class AndroidBData extends BDataMobile {
    constructor(url) {
        super('AndroidBData', new loader_1.AndroidBDataLoader(url));
    }
    setCustomerSessionId(_customerSessionId) {
        throw new Error('Shouldn`t call "setCustomerSessionId "method in Android');
    }
    setContext(_context) {
        throw new Error('Shouldn`t call "setContext" method in Android');
    }
}
exports.AndroidBData = AndroidBData;
class WebBData extends BData {
    constructor(url) {
        super('WebBData', new loader_1.WebBDataLoader(url));
    }
}
exports.WebBData = WebBData;
//# sourceMappingURL=index.js.map